import React from "react";

const Input = ({
  name,
  label,
  type,
  placeholder,
  value,
  error,
  onChange,
  ...rest
}) => {
  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <input
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        id={name}
        type={type}
        {...rest}
      />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;
